module.exports = __webpack_public_path__ + "img/TABELA_SALARIAL_ICON.64a77405.svg";